import React from "react";
import { Snackbar, SnackbarContent, IconButton, Typography }from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import { green } from "@material-ui/core/colors";

const BreytaAtkvaediSnackbar = (props) => {
  const { open, handleClose } = props;

  return (
    <Snackbar
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
    >
      <SnackbarContent
        style={{ backgroundColor: green[600] }}
        message={
          <span
            id="success-snackbar"
            style={{ alignItems: "center", display: "flex" }}
          >
            <CheckCircleIcon style={{ marginRight: "8px" }} />
            <Typography>Atkvæðinu hefur verið breytt</Typography>
          </span>
        }
        action={
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        }
      />
    </Snackbar>
  );
}

export default BreytaAtkvaediSnackbar;